import { useCallback, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { clearBonusCode, setBonusCode } from '@/api/auth';
import { Modals } from '@/helpers/modals';
import { useCommonStore, useModalsStore } from '@/store';
import { REASON_FOR_UPDATING_USER } from '@/store/commonStore/slices/auth/helpers';

export const useHandleBonus = (code: string | null | undefined) => {
  const { fetchUser, pendingUser, user } = useCommonStore(
    useShallow((state) => ({
      fetchUser: state.fetchUser,
      pendingUser: state.pendingUser,
      user: state.user,
    }))
  );
  const [bonusPending, setBonusPending] = useState(false);

  const open = useModalsStore.use.open();
  const handleBonus = useCallback(async () => {
    if (user?.canIssueBonuses) {
      setBonusPending(true);
      try {
        code
          ? await setBonusCode({ depositBonusCode: code })
          : await clearBonusCode();

        await fetchUser(REASON_FOR_UPDATING_USER.DEPOSIT);
      } catch (error) {
        console.error(error);
        return;
      } finally {
        setBonusPending(false);
      }
    }

    open(Modals.Deposit);
  }, [user?.canIssueBonuses, code, fetchUser, open]);

  return {
    handleBonus,
    pendingBonus: bonusPending || pendingUser,
  };
};
